import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { column, columnOf, maybeColumnOf } from './utils/helper';
import { createGroups, normalizeComparator, applyOrder, domainOf } from './utils/order';
/**
 * The dodge group marks into series by color or series channel,
 * and then produce new series channel for each series by specified order,
 * say to form horizontal "columns" by specified channels.
 */
export var DodgeX = function DodgeX() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$groupBy = options.groupBy,
    groupBy = _options$groupBy === void 0 ? 'x' : _options$groupBy,
    _options$reverse = options.reverse,
    reverse = _options$reverse === void 0 ? false : _options$reverse,
    orderBy = options.orderBy,
    padding = options.padding,
    rest = __rest(options, ["groupBy", "reverse", "orderBy", "padding"]);
  return function (I, mark) {
    var data = mark.data,
      encode = mark.encode,
      scale = mark.scale;
    var scaleSeries = scale.series;
    var _columnOf = columnOf(encode, 'y'),
      _columnOf2 = _slicedToArray(_columnOf, 1),
      Y = _columnOf2[0];
    var _maybeColumnOf = maybeColumnOf(encode, 'series', 'color'),
      _maybeColumnOf2 = _slicedToArray(_maybeColumnOf, 1),
      S = _maybeColumnOf2[0];
    var domainSeries = domainOf(S, scaleSeries);
    // Create groups and apply specified order for each group.
    var groups = createGroups(groupBy, I, mark);
    var createComparator = normalizeComparator(orderBy);
    var comparator = createComparator(data, Y, S);
    if (comparator) applyOrder(groups, comparator);
    // Update series for each mark related to series domain.
    var newS = new Array(I.length);
    var _iterator = _createForOfIteratorHelper(groups),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var G = _step.value;
        if (reverse) G.reverse();
        for (var i = 0; i < G.length; i++) {
          newS[G[i]] = domainSeries[i];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [I, deepMix({}, mark, {
      scale: {
        series: {
          domain: domainSeries,
          paddingInner: padding
        }
      },
      encode: {
        series: column(newS)
      }
    })];
  };
};
DodgeX.props = {};